import { IBGE_ESTADOS_GET, IBGEState, IBGETypes } from 'domain/types/ibge/estado/estado' 

const INITIAL_STATE: IBGEState = {
    EstadosBrasil: undefined,
}

export function IBGEReducer(state = INITIAL_STATE, action: IBGETypes): IBGEState {
    switch (action.type) {
        case IBGE_ESTADOS_GET:
            return { ...state, EstadosBrasil: action.payload }

        default:
            return state
    }
}